import { render, staticRenderFns } from "./homeTab.vue?vue&type=template&id=5572d30a&scoped=true&"
import script from "./homeTab.vue?vue&type=script&lang=js&"
export * from "./homeTab.vue?vue&type=script&lang=js&"
import style0 from "./homeTab.vue?vue&type=style&index=0&id=5572d30a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5572d30a",
  null
  
)

export default component.exports